import React from 'react';
import { Modal } from '../../../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Icon } from '../../../../CommonComponents/OPL/Icon/Icon';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';

interface Props {
  title: string;
  status: 'success' | 'warning' | 'error';
  children?: React.ReactNode;
  action?: {
    label: string;
    onClick(): void;
  };
  onClose?(): void;
}

const iconMap = {
  success: 'fas fa-check-circle',
  warning: 'fas fa-exclamation-triangle',
  error: 'far fa-times-circle',
};

const iconColorMap = {
  success: 'success.500',
  warning: 'warning.400',
  error: 'error.500',
};

export const StatusScreen = ({ title, children, status, action, onClose }: Props) => {
  return (
    <Modal isOpen onRequestClose={onClose}>
      {onClose && <ModalCloseButton onClick={onClose} />}

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        px="24"
        pt={72}
        pb={action ? 24 : 72}
      >
        <Text fontWeight={600} fontSize="h4" color="neutral.600">
          {title}
        </Text>

        <Icon className={iconMap[status]} color={iconColorMap[status]} fontSize="large" mt="24" />

        {children && (
          <Text color="neutral.500" textAlign="center" mx="48" mt="24">
            {children}
          </Text>
        )}

        {action && (
          <Box display="flex" flexDirection="column" width="100%" mt="32">
            <Button onClick={() => action.onClick()}>{action.label}</Button>
          </Box>
        )}
      </Box>
    </Modal>
  );
};
